import useApp from 'hooks/useApp';
import React from 'react';
import style from './agent-typing.module.css'
import PulseLoader from 'components/PulseLoader';
import { DEFAULT_LANGUAGE } from 'translations';

interface Props { }

const AgentTypingIndicator: React.FC<Props> = (props) => {
    const { isAgentTyping, language, appTextTranslations } = useApp();
    const agentIsTyping = appTextTranslations?.agentIsTyping?.[language] ?? appTextTranslations?.agentIsTyping?.[DEFAULT_LANGUAGE];

    return (
        <p className={style.agentTypingIndicator}>
            {isAgentTyping && (
                <>
                    <PulseLoader size={4} />
                    <span>{agentIsTyping}</span>
                </>
            )}
        </p>
    )
}

export default AgentTypingIndicator;